import { Node, Transforms, Editor, Element } from 'slate'
import { ElementWithType } from '../../../../../../utils/types';
import { JsonNode, INodeAttrs } from '../../../utils/types'
import { getSelectedCellsInATable } from '../table/utils/getSelectedCellsInATable';

const formAttributes = (oldAttributes: { style: {} }, alignment: string) => {
    let redactorAttributes: Partial<INodeAttrs> = {}

    if (oldAttributes) {
        redactorAttributes = {
            ...redactorAttributes,
            ...oldAttributes["redactor-attributes"]
        }
    }

    const elementAttribute = {
        attrs: {
            ...oldAttributes,
            style: {
                ...oldAttributes?.style,
                "text-align": alignment
            },
            "redactor-attributes": redactorAttributes
        }
    }

    return elementAttribute;
}

export const alignNode = (editor, alignment) => {
    const { selection } = editor;
    if (selection === null) {
        return
    }

    const [table] = Editor.nodes(editor, {
        match: (n: ElementWithType) => {
            return n.type === 'table'
        },
        mode: 'lowest'
    })

    const cells = table && Array.from(getSelectedCellsInATable(editor, table[1]))
    if (cells) {
        cells.forEach(([cell, cellPath]) => {
            const elementAttribute = formAttributes((cell as ElementWithType).attrs, alignment);
            Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: cells.length === 1 ? selection : cellPath })
        });
    }
    else {
        for (const [n, p] of Editor.nodes(editor, { at: selection })) {
            const node: JsonNode = n
            const path = p
            if (Element.isElement(node) && node.type !== 'doc' && node.type !== 'table') {
                const oldAttributes: any = node.attrs

                let redactorAttributes: Partial<INodeAttrs> = {}

                if (oldAttributes) {
                    redactorAttributes = {
                        ...redactorAttributes,
                        ...oldAttributes["redactor-attributes"]
                    }
                }
                if (node.type === 'img' || node.type === 'reference') {
                    redactorAttributes.position = alignment
                }

                const elementAttribute = {
                    attrs: {
                        ...oldAttributes,
                        style: {
                            ...oldAttributes?.style,
                            "text-align": alignment
                        },
                        "redactor-attributes": redactorAttributes
                    }
                }
                const [liNode] = Editor.nodes(editor, {
                    match: (n: any) => n.type === 'li',
                    at: selection,
                    mode: 'lowest'
                })
                if (liNode) Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: liNode[1] })
                else Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: selection })
            }
            Transforms.select(editor, selection)
        }
    }

}


export const isNodeAligned = (editor, style) => {
    const selection = editor.selection;

    if (selection === null) {
        return false
    }

    const [node] = Editor.nodes(editor, { match: (n: any) => n?.attrs?.style?.["text-align"] })
    //@ts-ignore
    if (node) return node[0].attrs.style["text-align"] === style
    else return style === 'left'
}
